// extracted by mini-css-extract-plugin
module.exports = {"info-tooltip":"Info_info-tooltip__WM_VL","tooltip-right":"Info_tooltip-right__3jQeP","tooltip-left":"Info_tooltip-left__2wpuc"};